import gql from 'graphql-tag';

const CREATE_PROJECT_CATEGORY = gql`
  mutation createProjectCategory (
    $data: ProjectCategoryCreateInput!
  ) {
    createProjectCategory (data: $data) {
      id
      parentId
      name
      path
      sortOrder
      level
    }
  }
`;

export default CREATE_PROJECT_CATEGORY;
